import { baseApi } from "./index";

export const patentApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getPatent: builder.query({
            query: ({ locale }) => ({
                url: `patent`,
                method: "GET",
                params: {
                    locale,
                },
            }),
            providesTags: ["Patent"],
        }),
    }),
});

export const {
    useGetPatentQuery,
} = patentApi;
